import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "./styles";
import SearchBar from "./searchBar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import SidebarItemComponent from "../sidebaritem/sidebarItem";
import Card from "@material-ui/core/Card";
import Dialog from "@material-ui/core/Dialog";
import NuevoCasoDialog from "./NuevoCasoDialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import firebase2 from "../../../firebase";
const firebase = require("firebase");
require("firebase/firestore");

class SidebarComponent extends React.Component {
  constructor(props) {
    super();
    this.state = {
      serachTerm: "",
      addingNote: false,
      title: "",
      usuario: "",
      email: "",
      rfc: "",
      estado: 1,
      cuenta: null,
      open2: false
    };
  }

  setSearchTerm = e => {
    this.setState({ serachTerm: e.target.value });
  };
  render() {
    const { notes, classes, selectedNoteIndex } = this.props;
    const { serachTerm } = this.state;

    if (notes) {
      const casos = notes.filter(item => item.estado === this.state.estado);
      const filteredData = casos.filter(
        item =>
          item.title
            .toLocaleLowerCase()
            .includes(serachTerm.toLocaleLowerCase()) ||
          item.body.toLocaleLowerCase().includes(serachTerm.toLocaleLowerCase())
      );
      return (
        <div className={classes.sidebarContainer}>
          <div style={{ width: "100%" }}>
            <SearchBar
              estado={this.state.estado}
              setSearchTerm={this.setSearchTerm}
              newNote={this.newNoteBtnClick}
              setCasosActivos={this.setCasosActivos}
              setCasosInactivos={this.setCasosInactivos}
              setCasosConcluidos={this.setCasosConcluidos}
            />
            <Dialog
              open={this.state.addingNote}
              onClose={this.newNoteBtnClick}
              aria-labelledby="form-dialog-title"
            >
              <NuevoCasoDialog
                newNoteBtnClick={this.newNoteBtnClick}
                title={this.state.title}
                usuario={this.state.usuario}
                email={this.state.email}
                newNote={this.newNote}
                updateUsuario={this.updateUsuario}
                updateEmail={this.updateEmail}
                updateRfc={this.updateRfc}
                listaUsuarios={this.props.usuarios}
                NuevoUsuario={this.NuevoUsuario}
              />
            </Dialog>
          </div>
          <List>
            <Card>
              <ListItem alignItems="flex-start">
                <div className={classes.textSection}>
                  <h4
                    className={classes.itemText}
                    style={{ width: "6%", textAlign: "center" }}
                  >
                    Caso
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "18%", textAlign: "center" }}
                  >
                    Cliente
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "10%", textAlign: "center" }}
                  >
                    Tipo Materia
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "10%", textAlign: "center" }}
                  >
                    Institucion
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "12%", textAlign: "center" }}
                  >
                    Tipo Reclamacion
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "10%", textAlign: "center" }}
                  >
                    Asunto
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "7%", textAlign: "center" }}
                  >
                    Etapa
                  </h4>
                  <h4
                    className={classes.itemText}
                    style={{ width: "27%", textAlign: "center" }}
                  >
                    Actualizado
                  </h4>
                </div>
              </ListItem>
            </Card>
          </List>
          <List>
            {filteredData.map((_note, _index) => {
              return (
                <Card key={_index} className={classes.card}>
                  <SidebarItemComponent
                    _note={_note}
                    _index={_index}
                    selectedNoteIndex={selectedNoteIndex}
                    selectNote={this.selectNote}
                    deleteNote={this.deleteNote}
                  />
                </Card>
              );
            })}
          </List>

          <Dialog
            /*fullScreen */

            open={this.state.open2}
            onClose={this.handleClose}
            aria-labelledby="form-dialog-title"
          >
            <div>
              <form
                className={classes.container}
                onSubmit={this.handleAddUser}
                autoComplete="off"
              >
                <DialogTitle id="form-dialog-title">
                  Agregar Cliente
                </DialogTitle>
                <DialogContent>
                  <DialogContentText> </DialogContentText>
                  {/*** Nombre de USUARIO ***/}
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    value={this.state.text}
                    onChange={e => this.setState({ text: e.target.value })}
                    label="Nombre"
                    variant="outlined"
                    type="name"
                    fullWidth
                    required
                  />
                  {/*** CORREO ELECTRONICO ***/}
                  <TextField
                    margin="dense"
                    id="email"
                    value={this.state.email}
                    onChange={e => this.setState({ email: e.target.value })}
                    label="correo electronico"
                    variant="outlined"
                    type="name"
                    fullWidth
                    required
                  />
                  {/*** CONTRASEñA ***/}
                  <TextField
                    margin="dense"
                    id="name"
                    value={this.state.rfc}
                    onChange={e => this.setState({ rfc: e.target.value })}
                    label="RFC"
                    variant="outlined"
                    type="name"
                    fullWidth
                    required
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary">
                    Cancelar
                  </Button>
                  <Button type="submit" variant="outlined" color="primary">
                    Guardar
                  </Button>
                </DialogActions>
              </form>
            </div>
          </Dialog>
        </div>
      );
    } else {
      return <div />;
    }
  }

  handleClose = () => {
    this.setState({
      open2: false
    });
  };

  NuevoUsuario = async () => {
    console.log("si me ejecuto weeeeeey asdasdasdasdasdas");
    this.setState({ open2: !this.state.open2 });
  };

  newNoteBtnClick = async e => {
    if (this.props.notes.length > 0) {
      /*let max = Math.max.apply(
        Math,
        this.props.notes.map(o => {
          return o.title.replace("-", "");
        })
      );
      max = max + "";
      this.setState({
        title:
          max.substring(max.length - 4) == new Date().getFullYear()
            ? `${parseInt(max.substr(0, max.length - 4)) +
                1}-${new Date().getFullYear()}`
            : `1-${new Date().getFullYear()}`
      });*/
      let cityRef = await firebase
        .firestore()
        .collection("contadorCasos")
        .doc("cuenta");
      let getDoc = cityRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            const data = doc.data();
            if (data.ano == new Date().getFullYear()) {
              let cuenta = data.cuenta;
              cuenta++;
              this.setState({
                title: `${cuenta}-${new Date().getFullYear()}`,
                cuenta: cuenta
              });
            } else {
              this.setState({
                title: `1-${new Date().getFullYear()}`,
                cuenta: 1
              });
            }
          }
        })
        .catch(err => {
          console.log("Error getting document", err);
        });
    } else {
      console.log("se esta yendo por el else");
      this.setState({
        title: `1-${new Date().getFullYear()}`,
        cuenta: 1
      });
    }
    await this.setState({
      // title: null,
      addingNote: !this.state.addingNote
    });
    //this.newNote();
  };

  updateUsuario = val => {
    this.setState({
      usuario: val,
      email: this.props.usuarios
        .filter(i => i.nombre == val)
        .map(i => {
          console.log(i.email);
          return i.email;
        }),
      rfc: this.props.usuarios
        .filter(i => i.nombre == val)
        .map(i => {
          console.log(i.contra);
          return i.contra;
        })
    });
  };

  updateEmail = val => {
    this.setState({
      email: val,
      usuario: this.props.usuarios
        .filter(i => i.email == val)
        .map(i => {
          console.log(i.nombre);
          return i.nombre;
        }),
      rfc: this.props.usuarios
        .filter(i => i.email == val)
        .map(i => {
          console.log(i.contra);
          return i.contra;
        })
    });

    console.log("actualizando los states", this.state.rfc);
  };

  updateRfc = txt => {
    this.setState({ rfc: txt.target.value });
  };

  newNote = async e => {
    e.preventDefault();
    let cuenta = 0;
    let title = "";
    let ano = "";
    if (this.props.notes.length > 0) {
      let cityRef = await firebase
        .firestore()
        .collection("contadorCasos")
        .doc("cuenta");
      let getDoc = await cityRef
        .get()
        .then(doc => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            const data = doc.data();
            if (data.ano == new Date().getFullYear()) {
              cuenta = data.cuenta;
              cuenta++;
              title = `${cuenta}-${new Date().getFullYear()}`;
              cuenta = cuenta;
            } else {
              title = `1-${new Date().getFullYear()}`;
              cuenta = 1;
            }
          }
        })
        .catch(err => {
          console.log("Error getting document", err);
        });
    } else {
      title = `1-${new Date().getFullYear()}`;
      cuenta = 1;
    }
    await firebase
      .firestore()
      .collection("contadorCasos")
      .doc("cuenta")
      .set({
        cuenta: cuenta,
        ano: new Date().getFullYear()
      });
    this.props.newNote(
      title,
      this.state.usuario,
      this.state.email,
      this.state.rfc
    );
    {
      /*  usuario        email       rfc   mandar parametros*/
    }
    this.setState({ title: null, addingNote: false });
  };
  selectNote = (n, i) => this.props.selectNote(n, i);
  deleteNote = note => this.props.deleteNote(note);
  setCasosActivos = () => {
    this.setState({ estado: 1 });
  };
  setCasosInactivos = () => {
    this.setState({ estado: 2 });
  };
  setCasosConcluidos = () => {
    this.setState({ estado: 3 });
  };
  handleAddUser = async e => {
    e.preventDefault();
    try {
      await firebase2.register(
        this.state.text,
        this.state.email,
        this.state.rfc,
        "cliente"
      );

      /*alert(
        "usuario" +
          "\n" +
          this.state.email +
          "\n" +
          "contraseña " +
          "\n" +
          this.state.rfc
      );*/

      this.setState({
        open2: false
      });
    } catch (error) {
      alert(error.message);
      this.setState({
        open2: false
      });
    }
  };
}
export default withStyles(styles)(SidebarComponent);
